import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import { Wrapper, Content , ContentRow} from './ListAssessments.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListAssessments extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.assessmentToggle = this.assessmentToggle.bind(this);
        this.assessmentSubmit =  this.assessmentSubmit.bind(this);
        this.sfToggle = this.sfToggle.bind(this);
        this.sfSubmit = this.sfSubmit.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'singleassessment/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async delete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral('assessments',row.rowData.id);
                  if (res.ok) {
                    
                    const assetCollectionsRes = await this.props.services. adminAPI.getAssessments();

                    if (assetCollectionsRes.ok) {
            
                        const collections = assetCollectionsRes.data.assessments;
                        
                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToEdit(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.delete(props)}>Delete</button>
          </td>
        );
    } 

    public assessmentToggle() {
        const data = this.state.data
        data.assessmentModal = !data.assessmentModal;
        this.setState({
            data
         });
    }

    public sfToggle() {
        const data = this.state.data
        data.sfModal = !data.sfModal;
        this.setState({
            data
         });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title", "Version", "TargetGroup", "Creator","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Version", "Target", "Creator", "Action"];

        const assessmentFormValues = {
            AssessmentVersion: '',
            User: currentUserID,
            Name: '',
            isPreAssessment: false,
            Enabled: false,
            TargetGroup: '',
            Ploa_Level: ''
        }

        const sfFormValues = {
            ConfigID: '',
            AssessmentID: '',
            Description: ''
         
        }

        const [assessmentsRes, targetsRes, levelsRes, sfRes] = await Promise.all([adminAPI.getAssessments(), adminAPI.getTargetGroups(), adminAPI.getUserLevels(), adminAPI.getSFConfigs()])

        if (assessmentsRes.ok) {

            const assessmentFormFields = [
                {
                    id: 'AssessmentVersion',
                    name: 'AssessmentVersion',
                    type: 'option',
                    placeholder: 'Enter Version',
                    options: {
                        items: [
                            {'Name': '0.5'},
                            {'Name': '1.0'}
                        ],
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Name'
                    },
                    required: true
                },
                {
                    id: 'TargetGroup',
                    name: 'TargetGroup',
                    type: 'option',
                    placeholder: 'Target Group',
                    options: {
                        items: targetsRes.data,
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Name'
                    },
                    required: true
                },
                {
                    id: 'isPreAssessment',
                    name: 'isPreAssessment',
                    type: 'option',
                    placeholder: 'PreAssessment',
                    options: {
                        items: [
                            {'Name': 'yes', 'Value': true},
                            {'Name': 'no', 'Value': false}
                        ],
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Value'
                    },
                    required: true
                },
                {
                    id: 'Ploa_Level',
                    name: 'Ploa_Level',
                    type: 'option',
                    placeholder: 'Level',
                    options: {
                        items: levelsRes.data,
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Name'
                    },
                    required: true
                },
                {
                    id: 'Name',
                    name: 'Name',
                    type: 'text',
                    placeholder: 'Enter Name',
                    required: true
                },
                {
                    id: 'Description',
                    name: 'Description',
                    type: 'text',
                    placeholder: 'Enter Description',
                    required: true
                }
    
            ] as FormFieldClass[];

            const sfFormFields = [
                {
                    id: 'AssessmentID',
                    name: 'AssessmentID',
                    type: 'option',
                    placeholder: 'Assessment',
                    options: {
                        items: assessmentsRes.data.assessments,
                        idkey: 'id',
                        labelkey: 'Title',
                        valuekey: 'id'
                    },
                    required: true
                },
                {
                    id: 'ConfigID',
                    name: 'ConfigID',
                    type: 'option',
                    placeholder: 'Config',
                    options: {
                        items: sfRes.data.configs,
                        idkey: 'id',
                        labelkey: 'ConfigName',
                        valuekey: 'id'
                    },
                    required: true
                },
                {
                    id: 'Description',
                    name: 'Description',
                    type: 'text',
                    placeholder: 'Enter Description',
                    required: false
                }
    
            ] as FormFieldClass[];
            
            const collections = assessmentsRes.data.assessments;

            this.setState(
                {
                     data: {
                        assessmentFormFields,
                        assessmentFormValues,
                        assessmentModal: false,
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead,
                        sfModal: false,
                        sfFormFields,
                        sfFormValues
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public async assessmentSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.assessmentFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('assessments', item);

        if (res.ok) {
            this.assessmentToggle();

            const assessmentsRes = await this.props.services.adminAPI.getAssessments();
            
            if(assessmentsRes.ok) {
                const data = this.state.data;

                data.collections = assessmentsRes.data.assessments;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public async sfSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.sfFormValues;

        const res = await this.props.services.adminAPI.createSFData(item);

        if (res.ok) {
            this.sfToggle();

            
            if(res.ok) {
                toast.success('SF Config Created');
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <Button onClick={this.assessmentToggle}>Add Assessment</Button>

                <Button onClick={this.sfToggle} style={{marginLeft: '3px', marginRight: '3px'}}>Add SearchFilters</Button>
                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              <ContentRow>
            
                    <FormModal 
                        visible={data.assessmentModal}
                        toggle={this.assessmentToggle}
                        formsubmit={this.assessmentSubmit}
                        formfields = {data.assessmentFormFields}
                        values={data.assessmentFormValues}
                        isbusy={!this.state.loaded}
                    />

                    <FormModal 
                        visible={data.sfModal}
                        toggle={this.sfToggle}
                        formsubmit={this.sfSubmit}
                        formfields = {data.sfFormFields}
                        values={data.sfFormValues}
                        isbusy={!this.state.loaded}
                    />
                    
                </ContentRow>

              
              </Wrapper>
        );

    }

}

export default withServices(ListAssessments);


// WEBPACK FOOTER //
// ./src/pages/Admin/Assessments/ListAssessments/ListAssessments.tsx